<template>
  <section>
    <component :is="viewComponent" />
  </section>
</template>

<script>
import ComponentLoaderObj from '@/objects/ComponentLoader';
import uiHelpers from '@/shared/ui_helpers';

export default {
  name: 'ComponentLoader',
  props: {},
  components: {
    Homepage: () => import(`@/components/homepage/Homepage.vue`),
    EventDetails: () => import(`@/components/event/eventDetails/EventDetails`),
  },
  mixins: [uiHelpers],
  data() {
    return {
      viewComponent: '',
      componentLoader: new ComponentLoaderObj(),
    };
  },
  mounted() {
    this.getInfoForKeys();
  },
  methods: {
    getInfoForKeys() {
      this.componentLoader
        .getInfoForKeys(this.$route.path)
        .then(() => {
          if (this.componentLoader.isEventType()) {
            let eventId = this.componentLoader.getEventId();
            this.$store.commit('event/setCurrentEventId', eventId);
            this.viewComponent = 'EventDetails';
            console.log(
              `ComponentLoader going to present Event: ${eventId} for key: ${this.componentLoader.getKeyForEvent()}`
            );
          }
        })
        .catch((error) => {
          console.log(
            `ComponentLoader received an error on route path: [${this.$route.path}]. Going back to HomePage.`
          );
          this.goToPage('Homepage');
        });
    },
  },
};
</script>
